import { render } from "./ProductTilesContainer.vue?vue&type=template&id=13301590"
import script from "./ProductTilesContainer.vue?vue&type=script&lang=js"
export * from "./ProductTilesContainer.vue?vue&type=script&lang=js"

import "./ProductTilesContainer.vue?vue&type=style&index=0&id=13301590&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__